import { render, staticRenderFns } from "./TimeByProject.vue?vue&type=template&id=2658c3b5&scoped=true&"
import script from "./TimeByProject.vue?vue&type=script&lang=js&"
export * from "./TimeByProject.vue?vue&type=script&lang=js&"
import style0 from "./TimeByProject.vue?vue&type=style&index=0&id=2658c3b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2658c3b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2658c3b5')) {
      api.createRecord('2658c3b5', component.options)
    } else {
      api.reload('2658c3b5', component.options)
    }
    module.hot.accept("./TimeByProject.vue?vue&type=template&id=2658c3b5&scoped=true&", function () {
      api.rerender('2658c3b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/timetracking/charts/TimeByProject.vue"
export default component.exports